/**
 * Shared remark/rehype plugin instances for ReactMarkdown.
 *
 * Hoisting these out of component bodies keeps the same array reference
 * across renders, which avoids ReactMarkdown re-running its plugin
 * pipeline on every parent re-render.
 */
import remarkGfm from "remark-gfm";

export const REMARK_PLUGINS = [remarkGfm];
